<template>
  <DuoPage/>
</template>

<script>
// @ is an alias to /src
import DuoPage from '@/components/DuoPage.vue'

export default {
  components: {
    DuoPage
  }
}
</script>
